"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveMuiTheme = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _styles = require("@material-ui/core/styles");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveMuiTheme = function retrieveMuiTheme(theme) {
  return (0, _styles.createMuiTheme)({
    typography: {
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily'])
    },
    overrides: {
      MuiFormControlLabel: {
        label: {
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'label', 'fontSize'], 14),
          color: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'label', 'color'], _colors["default"].primary)
        }
      },
      MuiFormHelperText: {
        root: {
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'helperText', 'fontSize'], 14),
          color: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'helperText', 'color'], _colors["default"].primary),
          '&$error': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'helperText', 'errorColor'], _colors["default"].error)
          }
        }
      },
      MuiCheckbox: {
        root: {
          color: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'checkbox', 'color'], _colors["default"].gray)
        },
        colorPrimary: {
          color: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'checkbox', 'color'], _colors["default"].gray),
          '&$checked': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTCheckList', 'checkbox', 'checkedColor'], _colors["default"].inputPrimary)
          }
        }
      }
    }
  });
};

exports.retrieveMuiTheme = retrieveMuiTheme;